import config from './main.config';
import translationsConfig from './_translations/en';
import run from './main.run';

import bbUtilities from '../-utilities/main.module';

export default angular
    .module('BB.i18n', [
        'tmh.dynamicLocale',
        bbUtilities
    ])
    .config(config)
    .config(translationsConfig)
    .run(run)
    .name;



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-i18n/main.module.js